import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, withKeys as _withKeys, normalizeStyle as _normalizeStyle, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, toHandlers as _toHandlers, mergeProps as _mergeProps } from "vue"

const _hoisted_1 = {
  class: "custom-report-button",
  "data-test": "custom-report-button-wrapper"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("span", { class: "caret" }, null, -1)
const _hoisted_3 = ["onClick", "onKeydown"]
const _hoisted_4 = { key: 0 }
const _hoisted_5 = { key: 1 }
const _hoisted_6 = ["onClick", "onKeydown"]
const _hoisted_7 = /*#__PURE__*/_createElementVNode("span", { class: "glyphicon glyphicon-pencil" }, null, -1)
const _hoisted_8 = [
  _hoisted_7
]
const _hoisted_9 = ["onClick", "onKeydown"]
const _hoisted_10 = /*#__PURE__*/_createElementVNode("span", { class: "glyphicon glyphicon-trash" }, null, -1)
const _hoisted_11 = [
  _hoisted_10
]
const _hoisted_12 = /*#__PURE__*/_createElementVNode("li", {
  role: "separator",
  class: "divider"
}, null, -1)
const _hoisted_13 = { key: 0 }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("span", { class: "glyphicon glyphicon-plus" }, null, -1)
const _hoisted_15 = {
  key: 1,
  class: ""
}
const _hoisted_16 = /*#__PURE__*/_createElementVNode("a", null, "Your team lead(s) can create reports for sub-teams here.", -1)
const _hoisted_17 = [
  _hoisted_16
]

import { computed, nextTick, ref, onMounted } from "vue";
import { v4 as uuid } from "uuid";

import { Dropdown } from "uiv";
import { CustomReportApiModel } from "../api-models";
import { validationErrors, CustomReportMemberTag } from "./custom-report-api-model";

import CustomReportEditor from "./custom-report-editor.vue";
import CustomReportDeleter from "./custom-report-deleter.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'custom-report-button',
  props: {
    id: {},
    noEditBecauseNotLeader: { type: Boolean, default: false },
    groups: { default: () => [] },
    kind: { default: "Team" },
    btnClass: { default: "" },
    availableMemberTags: {}
  },
  setup(__props: any) {

const props = __props;

const dropdown = ref<typeof Dropdown>();

const editor = ref<InstanceType<typeof CustomReportEditor>[]>([]);

const deleter = ref<InstanceType<typeof CustomReportDeleter>[]>([]);

const patchUrl = computed(() => {
  if (props.kind === "Viewpoints") {
    return "/api/customviewpointsreport/";
  }
  return `/api/customteamreport/${props.id}`;
});

const redirectUrlBase = computed(() => {
  if (props.kind === "Team") {
    return "/teamreport/view/";
  }
  if (props.kind === "TeamViewpoints") {
    return "/teamviewpointsreport/view/";
  }
  if (props.kind === "Viewpoints") {
    return "/viewpoints/view/";
  }
  return undefined;
});

const deleteUrlBase = computed(() => {
  if (props.kind === "Viewpoints") {
    return "/api/customviewpointsreport/";
  }
  return "/api/customteamreport/";
});

const newGroups = ref<CustomReportApiModel[]>([]);
const deletedGroups = ref<{ [id: string]: boolean }>({});

const canEdit = computed(() => {
  return !props.noEditBecauseNotLeader;
});

const allGroups = computed(() => {
  return props.groups.concat(newGroups.value);
});

const isError = (param: CustomReportApiModel): boolean => {
  return !!validationErrors(param)[0];
};

const edit = (group: CustomReportApiModel, validate?: boolean): void => {
  const editors = editor.value;
  const currentEditor = editors.filter((ed) => ed.getGroup().id === group.id)[0];

  if (validate) {
    currentEditor.validate();
  }
  currentEditor.open();
};

const create = (): void => {
  const newGroup: CustomReportApiModel = {
    id: uuid(),
    name: "",
    memberTags: [],
    kind: "Team",
  };
  newGroup.kind = props.kind;
  newGroups.value.push(newGroup);
  nextTick(() => edit(allGroups.value[allGroups.value.length - 1]));
};

const del = (group: CustomReportApiModel): void => {
  const deleters = deleter.value;
  const currentDeleter = deleters.filter((de) => de.getGroup().id === group.id)[0];
  currentDeleter.open();
};

const deleted = (group: CustomReportApiModel): void => {
  deletedGroups.value[group.id!] = true;
};

const view = (param: string | CustomReportApiModel): void => {
  let reportId: string;
  if (typeof param === "object") {
    if (!param.id) {
      throw new Error("This Group/Custom Report is missing an id.");
    }
    reportId = param.id;
  } else {
    reportId = param;
  }

  const href = `${redirectUrlBase.value}/${reportId}`.replace("//", "/");
  window.open(href, "_blank");
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("span", _hoisted_1, [
    _createVNode(_unref(Dropdown), {
      ref_key: "dropdown",
      ref: dropdown,
      "data-test": "custom-report-dropdown"
    }, {
      dropdown: _withCtx(() => [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(allGroups.value, (group) => {
          return (_openBlock(), _createElementBlock(_Fragment, null, [
            (group.id && group.name && group.memberTags.length > 1 && !deletedGroups.value[group.id])
              ? (_openBlock(), _createElementBlock("li", {
                  key: group.id,
                  style: {"position":"relative"},
                  class: "",
                  "data-test": "custom-report-dropdown-item"
                }, [
                  _createElementVNode("a", {
                    onClick: ($event: any) => (isError(group) ? edit(group, true) : view(group)),
                    onKeydown: _withKeys(($event: any) => (isError(group) ? edit(group, true) : view(group)), ["space"]),
                    role: "button",
                    style: _normalizeStyle(canEdit.value ? 'margin-right: 61px' : ''),
                    tabindex: "0"
                  }, [
                    (isError(group))
                      ? (_openBlock(), _createElementBlock("s", _hoisted_4, _toDisplayString(group.name), 1))
                      : (_openBlock(), _createElementBlock("span", _hoisted_5, _toDisplayString(group.name), 1))
                  ], 44, _hoisted_3),
                  (canEdit.value)
                    ? (_openBlock(), _createElementBlock("a", {
                        key: 0,
                        onClick: ($event: any) => (edit(group)),
                        onKeydown: _withKeys(($event: any) => (edit(group)), ["space"]),
                        role: "button",
                        "aria-label": "edit",
                        style: {"position":"absolute","right":"31px","top":"0","padding":"3px","width":"30px","text-align":"center"},
                        "data-test": "custom-report-edit-item-link",
                        tabindex: "0"
                      }, _hoisted_8, 40, _hoisted_6))
                    : _createCommentVNode("", true),
                  (canEdit.value)
                    ? (_openBlock(), _createElementBlock("a", {
                        key: 1,
                        onClick: ($event: any) => (del(group)),
                        onKeydown: _withKeys(($event: any) => (del(group)), ["space"]),
                        "aria-label": "delete",
                        role: "button",
                        style: {"position":"absolute","right":"1px","top":"0","padding":"3px","width":"30px","text-align":"center"},
                        "data-test": "custom-report-delete-item-link",
                        tabindex: "0"
                      }, _hoisted_11, 40, _hoisted_9))
                    : _createCommentVNode("", true)
                ]))
              : _createCommentVNode("", true)
          ], 64))
        }), 256)),
        _hoisted_12,
        (!_ctx.noEditBecauseNotLeader)
          ? (_openBlock(), _createElementBlock("li", _hoisted_13, [
              _createElementVNode("a", {
                role: "button",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (create())),
                onKeydown: _cache[1] || (_cache[1] = _withKeys(($event: any) => (create()), ["space"])),
                class: "",
                "data-test": "custom-report-create-button",
                tabindex: "0"
              }, [
                _hoisted_14,
                _createTextVNode(" Create a custom report ")
              ], 32)
            ]))
          : _createCommentVNode("", true),
        (_ctx.noEditBecauseNotLeader)
          ? (_openBlock(), _createElementBlock("li", _hoisted_15, _hoisted_17))
          : _createCommentVNode("", true)
      ]),
      default: _withCtx(() => [
        _createElementVNode("button", {
          class: _normalizeClass(["dropdown-toggle btn btn-default custom-report-button-btn", _ctx.btnClass]),
          "data-test": "custom-report-button",
          type: "button"
        }, [
          _createTextVNode(" Create "),
          _hoisted_2
        ], 2)
      ]),
      _: 1
    }, 512),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(allGroups.value, (group) => {
      return (_openBlock(), _createElementBlock("div", {
        key: 'editor.' + group.id
      }, [
        _createVNode(CustomReportEditor, _mergeProps({
          patchUrl: patchUrl.value,
          redirectUrlBase: redirectUrlBase.value,
          group: group,
          ref_for: true,
          ref_key: "editor",
          ref: editor,
          availableMemberTags: _ctx.availableMemberTags
        }, _toHandlers(_ctx.$attrs)), null, 16, ["patchUrl", "redirectUrlBase", "group", "availableMemberTags"])
      ]))
    }), 128)),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(allGroups.value, (group) => {
      return (_openBlock(), _createElementBlock("div", {
        key: 'deleter.' + group.id
      }, [
        _createVNode(CustomReportDeleter, _mergeProps({
          deleteUrlBase: deleteUrlBase.value,
          group: group,
          onDeleted: ($event: any) => (deleted(group)),
          ref_for: true,
          ref_key: "deleter",
          ref: deleter
        }, _toHandlers(_ctx.$attrs)), null, 16, ["deleteUrlBase", "group", "onDeleted"])
      ]))
    }), 128))
  ]))
}
}

})